export const getEnv = (): string => import.meta.env.MODE;
export const isDevMode = (): boolean => import.meta.env.DEV;
export const isProdMode = (): boolean => import.meta.env.PROD;
export const isStageMode = (): boolean => import.meta.env.MODE === "stage";

const ServerName = import.meta.env.VITE_BACKEND || "";

export { ServerName };
